// extracted by mini-css-extract-plugin
export default {"toggle":"toggle___37Ilm","open":"open___2wdPH","page":"page___36zzR","content":"content___2rQUo","main":"main___20r2u","header":"header___1u-Nw"};